import React, { useEffect, useRef } from 'react';

export interface Option {
  value: string;
  label: string | React.ReactElement;
}

interface DropdownMenuItemProps {
  option: Option;
  isSelected: boolean;
  onSelect: () => void;
}

const AUTOFOCUS_DELAY_MS = 25;

function DropdownMenuItem({ isSelected, onSelect, option }: DropdownMenuItemProps) {
  const button = useRef<HTMLButtonElement>(null);

  // Autofocus the selected element on mount
  useEffect(() => {
    if (!isSelected) return;
    // Prevent scroll-related flickering by delaying the autofocus
    setTimeout(() => button.current?.focus(), AUTOFOCUS_DELAY_MS);
  }, [isSelected]);

  return (
    <li>
      <button
        type="button"
        ref={button}
        data-testid={`contract option ${option.value}`}
        onClick={onSelect}
      >
        <span>{option.label}</span>
      </button>
    </li>
  );
}
export default DropdownMenuItem;
